<template>
  <button-component class="BackButton"
    :route="route"
    :label="label" />
</template>

<script>
export default {
  name: 'BackButton',

  props: {
    route: {
      type: Object
    },
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style>
.BackButton {
  margin: 24px auto 36px;
}
</style>



// WEBPACK FOOTER //
// BackButton.vue?5ebafcda